import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue } from '../../../../Fct/generics';
export var MultiSwap = createPlugin({
    protocol: 'PARASWAP',
    type: 'ACTION',
    method: 'multiSwap',
    supportedContracts: [{ address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57', chainId: 1 }],
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    sellData_tuple: {
                        fromToken: new FctAddress({}),
                        fromAmount: new FctValue({}),
                        toAmount: new FctValue({}),
                        expectedAmount: new FctValue({}),
                        beneficiary: new FctAddress({}),
                        'path_tuple{}': {
                            to: new FctAddress({}),
                            totalNetworkFee: new FctValue({}),
                            'adapters_tuple{}': {
                                adapter: new FctAddress({}),
                                percent: new FctValue({}),
                                networkFee: new FctValue({}),
                                'route_tuple{}': {
                                    index: new FctValue({}),
                                    targetExchange: new FctAddress({}),
                                    percent: new FctValue({}),
                                    payload: new FctBytes({}),
                                    networkFee: new FctValue({}),
                                },
                            },
                        },
                        partner: new FctAddress({}),
                        feePercent: new FctValue({}),
                        permit: new FctBytes({}),
                        deadline: new FctValue({}),
                    },
                },
            },
            output: {
                undefined: new FctValue({}),
            },
        });
    },
    requiredApprovals: function (params) {
        var _a = params.methodParams['sellData_tuple'], fromToken = _a.fromToken, fromAmount = _a.fromAmount;
        return [
            {
                to: fromToken.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: fromAmount.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
